import { useGetBuyerSpendingLimit } from '@api/lendingAPI/lapiHooks';
import { tracking } from '@iwoca/frontend-tracking-library';
import { Pill } from '@iwoca/orion';

import { RefreshExpiredLimits } from './RefreshExpiredLimits';
import { SpendingLimitBar } from './SpendingLimitBar';
import { FormattedCurrency } from '../../../../../iwIntlProvider/FormattedCurrency';
import styles from '../SpendingLimitCard.module.css';
import {
    checkHasThirtyDayAndThreeMonthLimit,
    formatDuration
} from './formatDuration';

export const ExpiredLimits = ({
    setIsSpendingLimitDrawerOpen,
    refreshSpendingLimit,
    loading
}: {
    setIsSpendingLimitDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
    refreshSpendingLimit: () => void;
    loading: boolean;
}) => {
    const { buyerSpendingLimit, loadingBuyerSpendingLimit } =
        useGetBuyerSpendingLimit();
    const spendingLimit = buyerSpendingLimit?.active_spending_limit;

    if (loadingBuyerSpendingLimit || !spendingLimit) return null;
    // Ensure the group formatting only happens when customer is active for the thirty day limit
    const hasThirtyDayAndThreeMonthLimit = checkHasThirtyDayAndThreeMonthLimit(
        buyerSpendingLimit?.spending_limits
    );

    return (
        <div className={styles.limits}>
            <div className={styles.left}>
                <div className={styles.remainingLimitHeader}>
                    <div>
                        You have{' '}
                        <FormattedCurrency
                            className={styles.remainingLimitAmount}
                            value={spendingLimit.available_amount}
                        />{' '}
                        left to spend
                    </div>
                    <Pill className={styles.estimatedPill}>Estimated</Pill>
                </div>
                <div className={styles.interestRateLabel}>
                    This is an estimated amount based on your last transaction
                    with us - refresh it by clicking “Secure my limit” or make a
                    purchase with Pay Later.
                </div>
            </div>
            <div className={styles.right}>
                <div className={styles.spendingLimitAmount}>
                    <div>
                        Estimated spending limit:{' '}
                        <FormattedCurrency value={spendingLimit.max_amount} />
                    </div>
                    <RefreshExpiredLimits
                        loading={loading}
                        setIsSpendingLimitDrawerOpen={
                            setIsSpendingLimitDrawerOpen
                        }
                        refreshSpendingLimit={refreshSpendingLimit}
                    />
                </div>
                <div className={styles.spendingLimitDurationLabel}>
                    {formatDuration({
                        duration: spendingLimit.duration_in_months,
                        groupSameLimits: hasThirtyDayAndThreeMonthLimit
                    })}{' '}
                    purchases{' '}
                    <button
                        onClick={() => {
                            tracking.ampli.spendingLimitViewedOtherTerms();
                            setIsSpendingLimitDrawerOpen(true);
                        }}
                        className={styles.otherTermsButton}
                    >
                        Other terms
                    </button>
                </div>
            </div>
            <div className={styles.bar}>
                <SpendingLimitBar status="expired" />
            </div>
        </div>
    );
};
